import { render, staticRenderFns } from "./icon.vue?vue&type=template&id=34282870&scoped=true"
import script from "./icon.ts?vue&type=script&lang=ts&external"
export * from "./icon.ts?vue&type=script&lang=ts&external"
import style0 from "./icon.vue?vue&type=style&index=0&id=34282870&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34282870",
  null
  
)

export default component.exports